
    <!--
 * 竖版-盲盒抽奖
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_9LBP81"  :class="[`normal`,`u_c_9LBP81`]" ><div id="u_c_5OC382"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_5OC382`]" ></div><div id="u_c_F9RS83"  v-html="compData.subTitle" :class="[`normal`,`u_c_F9RS83`]" ></div><div id="u_c_I4TP84"  :class="[`normal`,`u_c_I4TP84`]" ><span id="u_c_KSJG85"  :class="[`normal txt`,`u_c_KSJG85`]" >{{`${ langData.myCoupon }:`}}</span><span id="u_c_KFON87"  :class="[`normal txt count`,`u_c_KFON87`]" >{{`${ pageData.couponCount }`}}</span><a id="u_c_6JTI89" href="javascript:;" :class="[`normal txt`,`u_c_6JTI89`]" @click="u_c_6JTI89_event_MAWI24($event)">{{`[${ langData.checkGiftBtn }]`}}</a><a id="u_c_BIPC91" href="javascript:;" :class="[`normal txt`,`u_c_BIPC91`]" @click="u_c_BIPC91_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_JQ4E93"  :class="[`normal`,`u_c_JQ4E93`]" ><div id="u_c_D14494"  v-for="(giftItem, giftI) in compData.boxList" :key="giftI" :class="[`normal`,`u_c_D14494`]" ><div id="u_c_6R6I95"  :style="`background-image:url(${ compData.giftPic })`" :class="[`${ giftItem.cur ? 'light' : '' }`,`normal`,`u_c_6R6I95`]" ></div></div></div><div id="u_c_BZWR96"  :class="[`normal`,`u_c_BZWR96`]" ><a id="u_c_9LYG97" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" v-if="!bridge.runInsdk()" :class="[`${ compData.hidePay ? 'hide' : '' }`,`normal btn-light `,`u_c_9LYG97`]" @click="u_c_9LYG97_event_MAWI24($event)"><div id="u_c_BJCH98"  :class="[`normal page-common-btn`,`u_c_BJCH98`]" >{{`${ langData.gotoStoreBtn }`}}</div></a><a id="u_c_17K2100" href="javascript:;" :style="`background-image:url(${ pageData['lottery-btn-bg'] })`" :class="[`${ compData.canClick ? 'btn-light' : '' }`,`normal  `,`u_c_17K2100`]" @click="u_c_17K2100_event_334420($event)"><div id="u_c_3NGB101"  v-show="!(compData.is10 && pageData.couponCount >= 10)" :class="[`normal page-common-btn`,`u_c_3NGB101`]" >{{`${ compData.canClick ? langData.lotteryBtn : langData.inLottery }`}}</div><div id="u_c_5VHQ103"  v-show="compData.is10 && pageData.couponCount >= 10" :class="[`normal page-common-btn`,`u_c_5VHQ103`]" >{{`${ compData.canClick ? langData.lottery10 : langData.inLottery }`}}</div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒`,"lotteryList":[{"name":"袜子1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"袜子2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"袜子3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`天使的选择
盲盒活动`,"is10":false,"hidePay":false},"zh-CN":{"subTitle":`活动期间，通过【官网储值页面】任意渠道储值，每天累计储值金额每次达到19.99USD，都会获得一张抽奖券；`,"lotteryList":[{"name":"加速60分钟*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"普通招募硬币*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"荣耀印记*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"精造装置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"中级招募硬币*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"升星选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"强化选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"高级招募硬币*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"VIP点数100点*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"器官强化方案*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"精密升星选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"爱德华·蒂奇碎片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`庆典豪华礼盒`,"is10":false,"hidePay":false},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道儲值，每天累計儲值金額每次達到19.99USD，都會獲得一張抽獎券；`,"lotteryList":[{"name":"加速60分鐘*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"普通招募硬幣*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"榮耀印記*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"精造裝置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"中級招募硬幣","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"升星選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"強化選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"高級招募硬幣*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"VIP點數100點*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"器官強化方案*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"精密升星選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"愛德華·蒂奇碎片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`慶典豪華禮盒`,"is10":false,"hidePay":false},"en-US":{"subTitle":`During the event, every 19.99USD you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.`,"lotteryList":[{"name":"60-min Speedup*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Basic Recruit Coin*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Mark of Glory*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Gear Refiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Int. Recruit Coin","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Promote Choice Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Enhance Choice Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Adv. Recruit Coin*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 VIP Pts*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Bioenhance Scheme*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Promote Choice Box II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Deluxe Anniversary Box`,"is10":false,"hidePay":false},"ja-JP":{"subTitle":`イベント期間中、「公式チャージ画面」にて任意の決済方法で一日の合計チャージが19.99USDに達するたびに、抽選券を獲得できます。`,"lotteryList":[{"name":"ブースト（60分間）*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"リクルートコイン*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"グローリー*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"ギア装置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"ⓡ（リクルートコインミニ）","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"選択型プロモート補給*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"選択型強化補給*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Ⓡ（リクルートコイン）*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"VIPPt×100*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"器官強化プラン*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"選択型プロモート補給（エリート）*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"エドワード・ティーチの破片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`豪華記念ギフト`,"is10":false,"hidePay":false},"ko-KR":{"subTitle":`이벤트 기간 동안 공식 결제 플랫폼에서 19.99USD를 충전할 때마다 뽑기권 한 장이 주어집니다. 누적 충전 금액이 매일 리셋됩니다.`,"lotteryList":[{"name":"60분 가속*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"일반 모집 코인*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"영광 인장*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"정제 장치*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"중급 모집 코인","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"승성 선택 보급 상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"강화 선택 보급상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"고급 모집 코인*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"VIP 100포인트*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"신체 기관 강화 플랜*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"정밀 승성 선택 보급 상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"에드워드 티치*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`축제 호화 선물함`,"is10":false,"hidePay":false},"th-TH":{"subTitle":`ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สะสมครบครั้งละ 19.99USD ก็จะได้รับคูปองจับรางวัล 1 ใบ`,"lotteryList":[{"name":"เร่งสปีด60นาที*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"เหรียญเกณฑ์ I*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"ตรากลอรี่*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"เครื่องกลั่น*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"เหรียญเกณฑ์ II","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"หีบเลือกอัปดาว*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"หีบเลือกตีบวก*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"เหรียญเกณฑ์ III*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"แต้มVIPx100*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"แผนตีบวกอวัยวะ*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"หีบเลือกอัปดาวก่อสร้าง*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"เอ็ดเวิร์ด ทีช*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"คูปองลด 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"คูปองลด 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"คูปองลด 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`กล่องสุดหรูงานฉลอง`,"is10":false,"hidePay":false},"vi-VN":{"subTitle":`Trong thời gian hoạt động, Nạp thông qua kênh bất kỳ, mỗi lần tích lũy nạp đến 19.99 USD, để nhận một tấm Vé Rút Thưởng;`,"lotteryList":[{"name":"Tăng tốc 60 phút*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Xu Chiêu Mộ-Thường*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Ấn Ký Vinh Dự*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Tinh Luyện Trang Bị*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Xu Chiêu Mộ-Trung","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Rương Lựa Chọn Tăng Sao*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Rương Chọn Cường Hoá*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Xu Chiêu Mộ-Cao*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 điểm VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"P.Án C.Hóa Nội Tạng*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Rương Chọn Tăng Sao Tuyệt Mật*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Phiếu Ưu Đãi 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Phiếu Ưu Đãi 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Phiếu Ưu Đãi 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":``,"is10":false,"hidePay":false},"de-DE":{"subTitle":`Während des Events erhältst du für jede 19.99USD, die du jeden Tag über die offizielle Webseite von Puzzles & Survival auflädst, ein Glücksticket.`,"lotteryList":[{"name":"60 Min Beschleunigen*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Grund Rekrutmünze*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Zeichen des Ruhms*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Ausrüstung Verfeiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Mittl. Rekrutmünze","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Befördern Auswahlkiste*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Verbessern Auswahlkiste*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Fortg. Rekrutmünze*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 VIP Pkte*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Bioverstärkung Plan*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Befördern Auswahlkiste II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"5% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"7% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"9% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Deluxe Jubiläumskiste`,"is10":false,"hidePay":false},"fr-FR":{"subTitle":`Pendant l'événement, chaque fois que vous rechargerez 19,99 USD par jour via le site officiel de Puzzles & Survival, vous obtiendrez un Ticket Chance.`,"lotteryList":[{"name":"Accélération 60-min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Pièce recrutement de base*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Marque de gloire*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Raffineur d'équipement*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Pièce recrutement intermédiaire","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Boîte choix promotion*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Boîte de renforcement au choix*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Pièce recrutement av.*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Pt. VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Schéma Biorenforceur*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Boîte choix promotion II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Coupon 5% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Coupon 7% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Coupon 9% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Boîte Anniversaire Deluxe`,"is10":false,"hidePay":false},"ru-RU":{"subTitle":`Каждое пополнение на сумму 19,99USD в день на официальном сайте «Puzzles & Survival» принесёт вам Счастливый Билет во время события.
`,"lotteryList":[{"name":"Ускорение (60 мин.)*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Монета Базового Найма*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Знак Славы*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Модернизатор Снаряжения*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Монета Хорошего Найма","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Ящик с Промоутерами на Выбор*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Ящик с Улучшениями на Выбор*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Монета Крутого Найма*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Пунктов VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"План Биомодификации*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Ящик с Промоутерами на Выбор II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Купон на 5% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Купон на 7% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Купон на 9% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Шикарный юбилейный ящик`,"is10":false,"hidePay":false},"es-ES":{"subTitle":`Durante el evento, recibirás un ticket de la suerte por cada 19.99USD que recargues todos los días en el sitio web oficial de Puzzles & Survival.`,"lotteryList":[{"name":"Aceleración de 60 min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Moneda de Reclutamiento Básica*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Marca de Gloria*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Refinador de Equipos*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Moneda de Reclutamiento Intermedia","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Caja de Selección de Promoción*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Mejora la Caja de Elección*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Moneda de Reclutamiento Avanzada*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Puntos VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Plan de las Biomejoras*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Caja de Selección de Promoción II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Cupón de descuento del 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Cupón de descuento del 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Cupón de descuento del 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Caja de aniversario lujosas`,"is10":false,"hidePay":false},"pt-PT":{"subTitle":`Durante o evento, cada 19,99USD que você recarregar todos os dias através do site oficial do Puzzles & Survival, concederá a você um Bilhete da Sorte.
`,"lotteryList":[{"name":"Aceleração de 60 minutos*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Moeda Básica de Recrutamento*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Marca da Glória*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Refinador de Equipamentos*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Int. Moeda de Recrutar","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Caixa de Escolha de Promoção*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Caixa da Escolha de Melhorias*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Adv. Moeda de Recrutar*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Pontos VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Esquema de Melhoria de Órgãos*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Caixa de Escolha de Promoção II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Cupom de 5% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Cupom de 7% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Cupom de 9% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Caixa de Aniversário Deluxe`,"is10":false,"hidePay":false},"it-IT":{"subTitle":`Durante l'evento, ogni 19,99USD che ricarichi tramite il sito ufficiale di Puzzles & Survival ti garantirà un Biglietto Fortunato.`,"lotteryList":[{"name":"Velocizz. 60-min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Gettone Recluta Basica*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Marchio di Gloria*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Raffinatore Equip.*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Gettone Recluta Intermedia","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Scatola Scelta Promozione*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Scatola Scelta Migliora*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Gettone Recluta Avanzata*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Pti VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Schema Biopotenziatore*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Scatola Scelta Promozione II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Coupon SCONTO 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Coupon SCONTO 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Coupon SCONTO 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Scatola Anniversario Deluxe
`,"is10":false,"hidePay":false},"tr-TR":{"subTitle":`Etkinlik boyunca, Puzzles & Survival'ın resmi web sitesi aracılığıyla her gün yüklediğin her 19,99USD sana bir Şans Bileti verecek.`,"lotteryList":[{"name":"60-dk Hızlandırma*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Temel İşe Alım Parası*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Şan Mührü*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Teçhizat Arıtıcı*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Ara İşe Alım Parası","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"İlerletme Seçim Kutusu*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Büyütme Seçimi Kutusu*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Gel. İşe Alım Parası*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 VIP Puanı*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Bio-Geliştirme Şeması*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"İlerletme Seçim Kutusu II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"%5 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"%7 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"%9 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Caixa de Aniversário Deluxe`,"is10":false,"hidePay":false},"pl-PL":{"subTitle":`Podczas wydarzenia, każda kwota 19,99 USD, którą doładujesz codziennie za pośrednictwem oficjalnej strony Puzzles & Survival, przyzna Ci Szczęśliwy Bilet.
`,"lotteryList":[{"name":"60-min. Przyśpieszenie*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Moneta Rekruta Podstawowego*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Odznaka Chwały*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Rafiner Sprzętu*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Moneta Średniozaawansowanego Rekruta","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Pudełko z Wyborem Promocji*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Pudło Wyboru Wzmocnienia*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Moneta Rekruta Zaawansowanego*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 Pkt VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Biowzmacniacz Schemat*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Pudełko z Wyborem Promocji II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Kupon 5% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Kupon 7% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Kupon 9% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Luksusowe Pudełko Rocznicowe
`,"is10":false,"hidePay":false},"id-ID":{"subTitle":`Selama Event, lakukan Top Up dengan cara pembayaran apa pun. Jika akumulasi Top Up harian mencapai 19,99 USD, akan mendapat 1 Tiket Undi.`,"lotteryList":[{"name":"Speed up 60 menit*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"Normal Rekrut Coin*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"Mark of Glory*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"Gear Refiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"Medium Rekrut Coin","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"Star up Choice Supply Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"Enhance Choice Supply Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"Adv. Rekrut Coin*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 poin VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"Solusi Enhance Organ*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"Star up Choice Supply Box II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"Edward Teach Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"Kupon 5%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Kupon 7%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"Kupon 9%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Celebration Luxury Box
`,"is10":false,"hidePay":false},"ar-SA":{"subTitle":`خلال الحدث، قم بالشحن من خلال أي وسيلة شحن، وفي كل يوم تصل فيه قيمة الشحن التراكمية إلى 19.99 دولار، ستحصل على تذكرة يانصيب.`,"lotteryList":[{"name":"تسريع 60 دقيقة*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620267415712.png"},{"name":"عملات التجنيد العادي*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620204938504.png"},{"name":"وسام المجد*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620396167135.png"},{"name":"مطور المعدات*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620317342190.png"},{"name":"عملات التجنيد المتوسط","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620205408289.png"},{"name":"صندوق ترقية النجوم*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620304656209.png"},{"name":"اختيار صندوق الإمدادات*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620334218714.png"},{"name":"عملات التجنيد المتقدم*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620301545793.png"},{"name":"100 نقطة VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620217477123.png"},{"name":"طريقة تقوية الأعضاء*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620339881629.png"},{"name":"صندوق ترقية النجوم II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129620208818325.png"},{"name":"إدوارد تيتش*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129752460247754.png"},{"name":"1* قسيمة تخفيض 5%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"1* قسيمة تخفيض 7%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"},{"name":"1* قسيمة تخفيض 9%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172137923715294928.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299175783-57.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`هدية الاحتفال الفاخرة
`,"is10":false,"hidePay":false}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '盲盒抽奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const curPlatform = pagePlatform;

watch(
  () => listData,
  (value) => {
    if (value && value.lotteryList) {
      let confList = _.cloneDeep(compData.lotteryList)
      compData.lotteryList = []
      value.lotteryList.forEach((item, index) => {
        if (confList[index]) {
          compData.lotteryList.push({
            state: pageData.lotteryType == "no_reset" ? item.send_status : 0,
            id: item.id,
            name: confList[index].name,
            pic: confList[index].pic,
            cur: index ? 1 : 0,
          })
        }
      })
      giftInfo.lotteryAward = compData.lotteryList
    }
  }, {
    deep: true
  }
)

const init = () => {
  compData.canClick = true
  compData.storeLink = getCurLink(compData.storeLink)
  compData.boxList.forEach((item, index) => {
    item.cur = index ? 0 : 1
  })
}

init()

const getGiftName = (data) => {
  let name = ""
  if (data.send_type == "sendSerial") {
    name = `${langData.giftCode}：${data.send_value}`
  } else {
    let curId = compData.lotteryList.findIndex((item) => item.id == data.id)
    if (~curId) {
      name = compData.lotteryList[curId].name
    }
  }

  return name
}

const excLottery = async () => {
  let isMutiple = compData.is10 && pageData.couponCount >= 10
  let res = await excLotteryAjax(isMutiple)
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
    return
  }

  let curGiftType = isMutiple ? "sendVt" : res.data.send_type
  let curGiftPic = isMutiple ? "" : compData.giftPic
  let curGiftName = ""
  let curUse = 0

  if (isMutiple) {
    for (let i in res.data) {
      if (res.data[i].id != 0) {
        curUse++
        curGiftName += `${getGiftName(res.data[i])}<br/><br/>`
      }
    }
    if (curUse < 10) {
      curGiftName = `${curGiftName}${langData.lottery10error.replace(
        /{{n}}/,
        String(curUse)
      )}`
    }
  } else {
    curGiftName = getGiftName(res.data)
  }

  let currentUse = isMutiple ? curUse : 1

  pageData.couponCount = +pageData.couponCount - currentUse
  pageData.lotteryTime = +pageData.lotteryTime + currentUse

  showGetSucc(curGiftType, curGiftPic, curGiftName)
}

const excLotteryAjax = async (isMutiple) => {
  let curAction = isMutiple ? "batchLotteryAward" : "lotteryAward"
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=${curAction}`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=${curAction}`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=${curAction}`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  return res
}

// 盲盒轮闪
const TIMER = 500
let latestTime = new Date().getTime()
const updateLight = () => {
  let nowTime = new Date().getTime()
  if (nowTime - latestTime > TIMER) {
    latestTime = nowTime
    let latestIndex = compData.boxList.findIndex((item) => item.cur == 1)
    if (~latestIndex) {
      compData.boxList[latestIndex].cur = 0
      let nextIndex =
        latestIndex == compData.boxList.length - 1 ? 0 : latestIndex + 1
      compData.boxList[nextIndex].cur = 1
    }
  }
  window.requestAnimationFrame(updateLight)
}
updateLight()

if (utils.getUrlParams("scid") == 'menu') {
  compData.hidePay = true;
};
      // 查看奖励按钮的click事件
      const u_c_6JTI89_event_MAWI24= async (e)=>{
        try {let arr = [];
compData.lotteryList.forEach(item=>{
  arr.push({
    name:item.name,
    pic:item.pic
  })
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 更新按钮的click事件
      const u_c_BIPC91_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 去充钱的click事件
      const u_c_9LYG97_event_MAWI24= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '前往储值',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
bridge.open(pageData.storeLink)
} catch (error) {console.log(error)}
      };
      // 抽奖按钮的click事件
      const u_c_17K2100_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await excLottery()
compData.canClick = true} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.default{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.default{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.default{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.default{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.default{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.default{
.u_c_D14494.normal{
position:relative;

}
}.default{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.default{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.default{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.default{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.default{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.default{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.zh-CN{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.zh-CN{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-CN{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.zh-CN{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.zh-CN{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.zh-CN{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.zh-CN{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.zh-CN{
.u_c_D14494.normal{
position:relative;

}
}.zh-CN{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.zh-CN{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.zh-CN{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.zh-CN{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.zh-CN{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.zh-CN{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.zh-TW{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.zh-TW{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.zh-TW{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.zh-TW{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.zh-TW{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.zh-TW{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.zh-TW{
.u_c_D14494.normal{
position:relative;

}
}.zh-TW{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.zh-TW{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.zh-TW{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.zh-TW{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.zh-TW{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.zh-TW{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.en-US{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.en-US{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.en-US{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.en-US{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.en-US{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.en-US{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.en-US{
.u_c_D14494.normal{
position:relative;

}
}.en-US{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.en-US{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.en-US{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.en-US{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.en-US{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.en-US{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.ja-JP{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ja-JP{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ja-JP{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.ja-JP{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.ja-JP{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.ja-JP{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.ja-JP{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.ja-JP{
.u_c_D14494.normal{
position:relative;

}
}.ja-JP{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.ja-JP{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.ja-JP{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.ja-JP{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.ja-JP{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.ja-JP{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.ko-KR{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ko-KR{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ko-KR{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.ko-KR{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.ko-KR{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.ko-KR{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.ko-KR{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.ko-KR{
.u_c_D14494.normal{
position:relative;

}
}.ko-KR{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.ko-KR{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.ko-KR{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.ko-KR{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.ko-KR{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.ko-KR{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.th-TH{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.th-TH{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.th-TH{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.th-TH{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.th-TH{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.th-TH{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.th-TH{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.th-TH{
.u_c_D14494.normal{
position:relative;

}
}.th-TH{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.th-TH{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.th-TH{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.th-TH{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.th-TH{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.th-TH{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.vi-VN{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.vi-VN{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.vi-VN{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.vi-VN{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.vi-VN{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.vi-VN{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.vi-VN{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.vi-VN{
.u_c_D14494.normal{
position:relative;

}
}.vi-VN{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.vi-VN{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.vi-VN{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.vi-VN{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.vi-VN{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.vi-VN{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.de-DE{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.de-DE{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.de-DE{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.de-DE{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.de-DE{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.de-DE{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.de-DE{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.de-DE{
.u_c_D14494.normal{
position:relative;

}
}.de-DE{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.de-DE{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.de-DE{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.de-DE{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.de-DE{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.de-DE{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.fr-FR{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.fr-FR{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.fr-FR{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.fr-FR{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.fr-FR{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.fr-FR{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.fr-FR{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.fr-FR{
.u_c_D14494.normal{
position:relative;

}
}.fr-FR{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.fr-FR{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.fr-FR{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.fr-FR{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.fr-FR{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.fr-FR{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.ru-RU{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ru-RU{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ru-RU{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.ru-RU{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.ru-RU{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.ru-RU{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.ru-RU{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.ru-RU{
.u_c_D14494.normal{
position:relative;

}
}.ru-RU{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.ru-RU{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.ru-RU{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.ru-RU{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.ru-RU{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.ru-RU{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.es-ES{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.es-ES{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.es-ES{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.es-ES{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.es-ES{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.es-ES{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.es-ES{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.es-ES{
.u_c_D14494.normal{
position:relative;

}
}.es-ES{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.es-ES{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.es-ES{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.es-ES{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.es-ES{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.es-ES{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.pt-PT{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.pt-PT{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.pt-PT{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.pt-PT{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.pt-PT{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.pt-PT{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.pt-PT{
.u_c_D14494.normal{
position:relative;

}
}.pt-PT{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.pt-PT{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.pt-PT{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.pt-PT{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.pt-PT{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.pt-PT{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.it-IT{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.it-IT{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.it-IT{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.it-IT{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.it-IT{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.it-IT{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.it-IT{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.it-IT{
.u_c_D14494.normal{
position:relative;

}
}.it-IT{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.it-IT{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.it-IT{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.it-IT{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.it-IT{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.it-IT{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.tr-TR{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.tr-TR{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.tr-TR{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.tr-TR{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.tr-TR{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.tr-TR{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.tr-TR{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.tr-TR{
.u_c_D14494.normal{
position:relative;

}
}.tr-TR{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.tr-TR{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.tr-TR{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.tr-TR{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.tr-TR{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.tr-TR{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.pl-PL{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.pl-PL{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pl-PL{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.pl-PL{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.pl-PL{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.pl-PL{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.pl-PL{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.pl-PL{
.u_c_D14494.normal{
position:relative;

}
}.pl-PL{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.pl-PL{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.pl-PL{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.pl-PL{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.pl-PL{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.pl-PL{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.id-ID{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.id-ID{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.id-ID{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.id-ID{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.id-ID{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.id-ID{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.id-ID{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.id-ID{
.u_c_D14494.normal{
position:relative;

}
}.id-ID{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.id-ID{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.id-ID{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.id-ID{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.id-ID{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.id-ID{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}.ar-SA{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264134-13.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ar-SA{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ar-SA{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.ar-SA{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.ar-SA{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.ar-SA{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.ar-SA{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.ar-SA{
.u_c_D14494.normal{
position:relative;

}
}.ar-SA{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.47rem;
height:1.84rem;

}
}.ar-SA{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:1.03rem;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_9LYG97.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}

.u_c_9LYG97.normal.hide{
display:none;

}
}.ar-SA{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.ar-SA{
.u_c_17K2100.normal{
position:relative;
width:5.65rem;
height:1.69rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.ar-SA{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.44rem;

}
}.ar-SA{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:1.15rem;

}
}
</style>
